import { z } from "zod";
import { MediaSchema } from "./media";
import { PartnerBadgeSchema } from "./badge";

export const CustomerStorySchema = z.object({
    id: z.number(),
    title: z.string(),
    slug: z.string(),
    /** @deprecated Use media instead */
    images: z.array(z.string()).nullable().optional(),
    media: z.array(MediaSchema).nullable().optional(),
    content: z.string().nullable().optional(),
    hired_at_shopexperts: z.boolean().nullable().optional(),
    start_date: z.string().nullable().optional(), // ISO date string
    end_date: z.string().nullable().optional(),   // ISO date string
    created_at: z.string(),
    badges: z.array(PartnerBadgeSchema).optional(),
});
